export default __webpack_public_path__ + "static/media/currency_rub.9379a55a.svg";